import ApiClient from '../../services/apiClient';
import { LookupDataEnums } from '../../utilities/Constants';
import { useLoading } from '../../contexts/LoadingContext';
import { useQuery } from 'react-query';

const _apiClient = new ApiClient();

export const useExpertTypesLookup = (enableLoader?: boolean) => {
    const loading = useLoading();

    return useQuery({
        queryKey: ['get-expert-types-lookup'],
        queryFn: async () => {
            const response = await _apiClient.getLookupData(LookupDataEnums.ExpertTypes);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve expert types.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        onSettled: enableLoader ? () => loading.hideLoading() : undefined,
        staleTime: Infinity,
        cacheTime: Infinity,
    });
};
